import { css } from '@emotion/react'

export const styles = () => ({
  form: {
    main: css``,
    content: {
      main: css``,
      email: css`
        margin-bottom: 32px;
      `,
      submit: css``,
    },
  },
})
